import { Injectable, Inject } from '@angular/core';
import { HttpModule, Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { APP_CONFIG, IAppConfig } from './../app.config';
import 'rxjs/add/observable/throw';

@Injectable()

export class PartnerQuestionsService {

  private _token: string = localStorage.getItem('token');
  constructor(
    private http: Http,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) { }

  getQuestionsData$(name): Observable<any> {
    const headers = new Headers({ 'Authorization': this._token });
    const options = new RequestOptions({ headers: headers });
    return this.http.get(this.config.apiEndpoint + 'partnerquestions/get-partner-questions/' + name, options).map((res => res.json()))
    .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  postFormData$(info1: any,info2: any): Observable<any> {
    const token = this._token;
    console.log(info1);
    console.log(info2);
    const formData = new FormData();
    formData.append('partnerid', info1.partnerid);
    formData.append('isCNIC', info1.isCNIC);
    formData.append('formdata', info1.formdata);
    formData.append('recommendationfile', info2.recommendationfile);
    formData.append('digitalsignfile', info2.digitalsignfile);
    formData.append('recommendtionFileid', info2.recommendtionFileid);
    formData.append('digitalsignFileid', info2.digitalsignFileid);
    console.log(formData);
    const headers = new Headers({'Authorization': token});
    return this.http.post(this.config.apiEndpoint + 'partnerquestions/save-student-answer', formData, {
        headers: headers
      })
      .catch(this.handleErrorObservable);
  }

  postFinalFormData$(info: any): Observable<any> {
    const token = this._token;
    const headers = new Headers({'Authorization': token});
    return this.http.post(this.config.apiEndpoint + 'partnerquestions/save-final-submit', info, {
        headers: headers
      })
      .catch(this.handleErrorObservable);
  }

  postDigitalData$(info: any): Observable<any> {
    const token = this._token;
    const headers = new Headers({'Authorization': token});
    return this.http.post(this.config.apiEndpoint + 'partnerquestions/save-student-digital-answer', info, {
        headers: headers
      })
      .catch(this.handleErrorObservable);
  }

  getStudnetAnswer$(info: any): Observable<any> {
    const headers = new Headers({ 'Authorization': this._token });
    const options = new RequestOptions({ headers: headers });
    return this.http.post(this.config.apiEndpoint + 'partnerquestions/get-student-answer', info, options)
      .map((res: Response) => res.json()) // ...and calling .json() on the response to return data
    .catch(this.handleErrorObservable); // ...errors if any

  }

  private handleErrorObservable (error: Response | any) {
    /*if(!error.json().error){
      alert('Please check your internet connection');
    }*/
    console.log(error);
    return Observable.throw( error);
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/_services/partner-questions.service.ts